<template>
  <el-dialog
    :title="ColumnData.label"
    :visible.sync="dialogVisible"
    width="90%"
    :before-close="handleClose"
    @open="GetRequestTasksData"
  >
    <rabbey-table-3
      :border="true"
      :stripe="true"
      :actions="TaskActions"
      @rtable-push-action="handlePushAction"
      :loading="loadingData"
      :data="FilteredTasks"
      :columns="TaskColumns"
      show-summary
      sum-text="Tiempo Total"
      :summary-method="getSummaries"
      page_Size="500"
      :pageSizes="[500, 1000]"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button type="primary" @click="dialogVisible = false"
        >Confirm</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { TaskReportActions } from "@/columns/TasksReportColumns";
import { TasksAndRequestColumns } from "@/columns/ProductiveHoursReport/ProductivesHoursColumns";

export default {
  name: "TasksAndRequestsList",
  props: {
    dialogVisibleProp: {
      type: Boolean,
      required: true
    },
    rowData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    ColumnData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    filters: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      TasksData: [],
      TaskColumns: TasksAndRequestColumns,
      TaskActions: TaskReportActions(this),
      loadingData: false
    };
  },
  computed: {
    dialogVisible() {
      return this.dialogVisibleProp;
    },
    FilteredTasks() {
      let filteredTasks = [];

      filteredTasks = this.TasksData;

      return filteredTasks;
    }
  },
  // async mounted() {
  //   await this.GetRequestTasksData();
  // },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit("CloseTaskListDialog", false);
    },
    async GetRequestTasksData() {
      console.log("rowData before fetch: ", this.rowData);
      console.log("ColumnData before fetch: ", this.ColumnData);
      console.log("filters before fetch: ", this.filters);

      // if (
      //   this.filters.Responsible === this.currentUser.EmployeeId ||
      //   this.AmIsupervisor
      // ) {
      this.loadingData = true;
      this.TasksData = [];
      let type = "";
      switch (this.ColumnData.property) {
        case "TotalClosedHours":
          type = "TC";
          break;
        case "TotalInternalRequestsClosedHours":
          type = "SI";
          break;
        case "TotalExternalRequestsClosedHours":
          type = "SE";
          break;
        case "TotalOperacionalTasksClosedHours":
          type = "TO";
          break;
        case "TotalEstrategicalTasksClosedHours":
          type = "TE";
          break;
        default:
          type = "";
          break;
      }
      // await Promise.all(
      await this.$http
        .get(
          "/api/ReporteGestion/Get_Detailed_List_Of_Productive_Hours_Report",
          {
            params: {
              ResponsableID: this.rowData.ResponsableID,
              DirecctionID: this.filters.Direction,
              DeparmentId: this.filters.Deparment,
              Year: this.filters.Year,
              Month: this.filters.Month,
              WeekOnMothSelected: this.filters.Week,
              Type: type
            }
          }
        )
        .then((response) => {
          this.TasksData = response.data;
          this.loadingData = false;
        })
        .catch(() => {
          this.loadingData = false;
          this.$message.error("Error al cargar los datos de las tareas.");
        })
        .finally(() => {
          this.loadingData = false;
        });
      // }
      // );
    },
    getSummaries(param) {
      const columnsToSum = [
        "TimeOntask"
        // "Monday",
        // "Tuesday",
        // "Wednesday",
        // "Thursday",
        // "Friday",
        // "Saturday",
      ];
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "Tiempo Total";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (
          !values.every((value) => isNaN(value)) &&
          columnsToSum.includes(column.property)
        ) {
          sums[index] =
            values
              .reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
              .toFixed(2) + " horas";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    async handlePushAction(option) {
      const { row } = option;

      switch (option.command) {
        case "view_task":
          this.DetailsDialogData = {
            requestsId: row.OriginalID,
            comments: [],
            descripcionLaga: row.Descripcion,
            descripcionCorta: row.Name,
            commentReasonToReopen: "",
            Reopen: "",
            evidences: []
          };
          this.isDetailsVisible = true;
          break;
        case "edit_task_time":
          this.whatsFor = option.command;
          row.TypeOfTime = "h"; // Default to "h"
          this.actualResquest = [row];
          this.isTimeAssigmentVisible = true;
          break;
        case "close_task":
          if (row.TimeOntask === 0) {
            this.$alert(
              "Antes de poder cerrar esta tarea debe asignarle tiempo a la misma",
              "Tarea sin tiempo asignado!",
              {
                confirmButtonText: "De acuerdo",
                type: "warning",
                callback: async (action) => {
                  this.$message({
                    type: "info",
                    message: `action: ${action}`
                  });
                  await this.openingTimeAsigment();
                }
              }
            );
          } else {
            this.RequestTaskId = option.row.ID;
            this.RequestTaskOriginalId = option.row.OriginalID;
            if (option.row.ID.startsWith("SE-")) {
              this.isCloseServiceRequestDialogVisible = true;
            } else {
              this.isEvidenceDialogVisible = true;
            }
          }
          break;
        case "edit_task_due_date":
          this.ActualTaskInfo = row;
          this.IsDueDateDialogVisible = true;
          break;
        case "edit_responsible":
          this.ActualTaskInfo = row;
          this.isResponsibleDialogVisible = true;
          break;
        case "order_tasks":
          this.RecalculateTaskData();
          break;
        case "delete_task":
          await this.$confirm(
            "¿Estás seguro de que deseas eliminar esta tarea?",
            "Confirmación",
            {
              confirmButtonText: "Sí",
              cancelButtonText: "No",
              type: "warning"
            }
          )
            .then(async () => {
              await this.$http
                .put("/api/ReporteGestion/DleteTask", {
                  Id: option.row.OriginalID,
                  Task: option.row.ID,
                  IsEneabled: false
                })
                .then(async () => {
                  this.TasksData = [];
                  await this.GetRequestTasksData();
                });
            })
            .catch(async () => {
              // Acción cancelada
              this.TasksData = [];
              await this.GetRequestTasksData();
            });
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
